import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CardapioMinishopCategoriaDTO } from '../../../../../models/cardapio-minishop/cardapio-minishop.model';

@Component({
  selector: 'app-cardapio-minishop-destaque',
  templateUrl: './cardapio-minishop-destaque.component.html',
  styleUrls: ['./cardapio-minishop-destaque.component.scss'],
})
export class CardapioMinishopDestaqueComponent implements OnInit, OnDestroy {
  @Input() categoriaDestaque: CardapioMinishopCategoriaDTO | null = null;
  @Input() maxDestaques = 10;

  @Output() adicionarDestaque = new EventEmitter<void>();
  @Output() toggleVisibilidade = new EventEmitter<void>();
  @Output() moverCima = new EventEmitter<void>();
  @Output() moverBaixo = new EventEmitter<void>();

  texts = {
    categoria_destaque: '',
    novo: '',
    adicionar_destaque: '',
  };

  private langChangeSub!: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) this.langChangeSub.unsubscribe();
  }

  get contadorDestaques(): string {
    const atual = this.categoriaDestaque?.produtos?.length || 0;
    return `${atual}/${this.maxDestaques}`;
  }

  private loadTranslations(): void {
    this.texts = {
      categoria_destaque: this.translate.instant('cardapio_minishop.destaque.categoria_destaque'),
      novo: this.translate.instant('cardapio_minishop.destaque.novo'),
      adicionar_destaque: this.translate.instant('cardapio_minishop.destaque.adicionar_destaque'),
    };
  }
}
